import styled from 'styled-components';
import CustomBlockButton from '../../../../../../../components/button/CustomBlockButton';
import _ from 'lodash';
import { useApiInfoContextValueHook } from '../../../../../../../contexts/ApiInfoContext';
import { SellertoolSignatureUtils } from '../../../../../../../utils/sellertool-signature-utils';
import { ReturnExchangesApi } from '../../../../../../../apis/ReturnExchangesApi';
import { useFetcher } from '../../../../fetcher/useFetcher';
import { CustomBackdropController } from '../../../../../../../components/backdrop/default/v1';
import { useEffect, useState } from 'react';
import { CustomDialog } from '../../../../../../../components/dialog/v1/CustomDialog';
import { CustomLabelInput } from '../../../../../../../components/input/CustomLabelInput';
import { customToast } from '../../../../../../../components/toast/custom-react-toastify/v1';
import { CustomDateUtils } from '../../../../../../../utils/CustomDateUtils';
import { ProductOptionsApi } from '../../../../../../../apis/ProductOptionsApi';
import { GlobalWegetProductOptionModal } from '../../../../../../../global-wegets/global-weget-product-option-modal';
import CustomSelect from '../../../../../../../components/select/default/v1/CustomSelect';
import { deliveryCompanyCodes } from '../../../../../variables/delivery-company-codes';

const StyledTableCell = styled.td`
  padding: 16px;
  color: #495057;
  border-bottom: 1px solid #dee2e6;

  .view-button{
    background-color: var(--blueColor1);
    color: #fff;
    border-radius: 3px;
    border:none;
    height: 30px;
    padding: 0 10px;
    font-weight: 600;
    cursor: pointer;
  }
`

const StyledModalHeader = styled.div`
    padding: 10px;
`;

const StyledModalBody = styled.div`
    padding: 10px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    input{
        border: 1px solid #dee2e6;
        border-radius: 3px;
    }

    select{
        border: 1px solid #dee2e6;
        border-radius: 3px;
    }

    .optionCodeButton{
        background-color: #333;
        color: #fff;
        border-radius: 3px;
        border:none;
        padding: 0 10px;
        font-weight: 600;
        cursor: pointer;
    }

    .product-info-box{
        border: 1px solid #dee2e6;
        padding:10px;
        border-radius: 5px;
        font-size: 14px;
        display: flex;
        flex-direction: column;
        gap: 10px;

        .label{
            font-weight: 600;
            color:#333;
        }

        .content{
            padding-left: 5px;
            margin-top:5px;
        }
    }
`;

const StyledModalFooter = styled.div`
    padding: 10px;

    button{
        border-radius: 3px;
        background-color: #333;
        color: #fff;
        font-weight: 600;
        border:none;
    }
`;

export function TdExchangeInfo({
    returnExchange
}) {
    const apiInfoContextValueHook = useApiInfoContextValueHook();
    const fetcher = useFetcher();

    const [editModalOpen, setEditModalOpen] = useState(false);

    const handleReqChange = async (editableData) => {
        const timestamp = Date.now().toString();
        const signature = SellertoolSignatureUtils().generateSigniture({
            apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
            secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
            timestamp: timestamp
        })

        const headers = {
            'x-sellertool-apiKey': apiInfoContextValueHook?.apiInfo?.apiKey,
            'x-sellertool-timestamp': timestamp,
            'x-sellertool-signiture': signature
        }
        CustomBackdropController().showBackdrop();
        const response = await ReturnExchangesApi().updateList({
            headers: headers,
            body: {
                returnExchanges: [editableData]
            }
        });

        if (response?.content) {
            await fetcher.fetchReturnExchanges();
        }
        setEditModalOpen(false);
        CustomBackdropController().hideBackdrop();
    }
    return (
        <>
            <StyledTableCell>
                <CustomBlockButton
                    type='button'
                    className='view-button'
                    onClick={(e) => { e.stopPropagation(); setEditModalOpen(true) }}
                >보기</CustomBlockButton>
            </StyledTableCell>

            {editModalOpen &&
                <EditModal
                    open={editModalOpen}
                    onClose={() => setEditModalOpen(false)}
                    returnExchange={returnExchange}
                    onReqChange={handleReqChange}
                />
            }
        </>
    );
}

function EditModal({
    open,
    onClose,
    returnExchange,
    onReqChange
}) {
    const apiInfoContextValueHook = useApiInfoContextValueHook();

    const [editableReturnExchange, setEditableReturnExchange] = useState(_.cloneDeep(returnExchange));
    const [productInfo, setProductInfo] = useState({
        productName: '',
        optionName: '',
    });
    const [productOptionSelectModalOpen, setProductOptionSelectModalOpen] = useState(false);


    useEffect(() => {
        if (!editableReturnExchange?.exchangeReleaseOptionCode) {
            return;
        }

        handleReqFetchProductOptions();
    }, [editableReturnExchange?.exchangeReleaseOptionCode])

    const handleReqFetchProductOptions = async () => {
        const timestamp = Date.now().toString();
        const signature = SellertoolSignatureUtils().generateSigniture({
            apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
            secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
            timestamp: timestamp
        })

        const headers = {
            'x-sellertool-apiKey': apiInfoContextValueHook?.apiInfo?.apiKey,
            'x-sellertool-timestamp': timestamp,
            'x-sellertool-signiture': signature
        }

        CustomBackdropController().showBackdrop();
        const response = await ProductOptionsApi().searchListByOptionCodes({
            headers: headers,
            body: {
                optionCodes: [editableReturnExchange?.exchangeReleaseOptionCode]
            }
        });

        if (response?.content && response?.content.length > 0) {
            setProductInfo({
                productName: response?.content[0]?.product?.name,
                optionName: response?.content[0]?.name
            });
        }
        CustomBackdropController().hideBackdrop();
    }

    const handleAutoComplete = () => {
        setEditableReturnExchange(prev => {
            return {
                ...prev,
                exchangeReleaseOptionCode: prev?.releaseOptionCode,
                exchangeReleaseQuantity: prev?.returnExchangeQuantity,
                exchangeReShipmentDestination: prev?.destination,
                exchangeReShipmentDestinationDetail: prev?.destinationDetail,
                exchangeReShipmentReceiver: prev?.receiver,
                exchangeReShipmentReceiverContact1: prev?.receiverContact1,
                exchangeReShipmentReceiverContact2: prev?.receiverContact2,
                exchangeReShipmentDeliveryCharge: prev?.deliveryCharge,
                exchangeReShipmentZipCode:prev?.zipCode,
            }
        })
    }

    const handleChangeValue = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        setEditableReturnExchange(prev => {
            return {
                ...prev,
                [name]: value
            }
        })
    }

    const handleSelectProductOption = (item) => {
        setEditableReturnExchange(prev => {
            return {
                ...prev,
                exchangeReleaseOptionCode: item?.productOptionCode
            }
        })
    }

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!editableReturnExchange.exchangeReleaseOptionCode) {
            customToast.error('교환상품 옵션코드를 입력해주세요.');
            return;
        }
        if (!editableReturnExchange.exchangeReleaseQuantity || editableReturnExchange.exchangeReleaseQuantity <= 0) {
            customToast.error('수량을 올바르게 입력해주세요.');
            return;
        }
        if (!editableReturnExchange.exchangeReShipmentReceiver) {
            customToast.error('수취인을 입력해주세요.');
            return;
        }
        if (!editableReturnExchange.exchangeReShipmentReceiverContact1) {
            customToast.error('수취인 전화번호1을 입력해주세요.');
            return;
        }
        if (!editableReturnExchange.exchangeReShipmentDestination) {
            customToast.error('주소를 입력해주세요.');
            return;
        }
        if(!editableReturnExchange.exchangeReShipmentDeliveryCompanyCode){
            customToast.error('택배사를 선택해주세요.');
            return;
        }
        if (editableReturnExchange.exchangeReShipmentDeliveryCharge && editableReturnExchange.exchangeReShipmentDeliveryCharge < 0) {
            customToast.error('재출고 배송비를 올바르게 입력해주세요.');
            return;
        }
        onReqChange(editableReturnExchange);
    }

    return (
        <>
            <CustomDialog
                open={open}
                onClose={onClose}
            >
                <StyledModalHeader>
                    <CustomDialog.Header>
                        <CustomDialog.Header.Fake />
                        <CustomDialog.Header.Title>
                            교환정보
                        </CustomDialog.Header.Title>
                        <CustomDialog.Header.Close onClick={() => onClose()} />
                    </CustomDialog.Header>
                </StyledModalHeader>
                <form onSubmit={handleSubmit}>
                    <StyledModalBody>
                        <CustomBlockButton
                            type='button'
                            className='optionCodeButton'
                            onClick={handleAutoComplete}
                        >
                            자동완성
                        </CustomBlockButton>
                        <div className='product-info-box'>
                            <div>
                                <div className='label'>교환상품 옵션코드</div>
                                <div className='content'><span style={{ cursor: 'pointer', textDecoration: 'underline' }} onClick={() => setProductOptionSelectModalOpen(true)}>{editableReturnExchange?.exchangeReleaseOptionCode || '선택'}</span></div>
                            </div>
                            <div>
                                <div className='label'>교환상품명</div>
                                <div className='content'>{productInfo?.productName || '옵션코드 미지정'}</div>
                            </div>
                            <div>
                                <div className='label'>교환옵션명</div>
                                <div className='content'>{productInfo?.optionName || '옵션코드 미지정'}</div>
                            </div>
                        </div>
                        <CustomLabelInput>
                            <CustomLabelInput.Input
                                type='number'
                                name='exchangeReleaseQuantity'
                                onChange={handleChangeValue}
                                value={editableReturnExchange?.exchangeReleaseQuantity || ''}
                            />
                            <CustomLabelInput.Label>수량</CustomLabelInput.Label>
                        </CustomLabelInput>
                        <CustomLabelInput>
                            <CustomLabelInput.Input
                                type='text'
                                name='exchangeReShipmentReceiver'
                                onChange={handleChangeValue}
                                value={editableReturnExchange?.exchangeReShipmentReceiver || ''}
                            />
                            <CustomLabelInput.Label>수취인</CustomLabelInput.Label>
                        </CustomLabelInput>
                        <CustomLabelInput>
                            <CustomLabelInput.Input
                                type='text'
                                name='exchangeReShipmentReceiverContact1'
                                onChange={handleChangeValue}
                                value={editableReturnExchange?.exchangeReShipmentReceiverContact1 || ''}
                            />
                            <CustomLabelInput.Label>수취인 전화번호1</CustomLabelInput.Label>
                        </CustomLabelInput>
                        <CustomLabelInput>
                            <CustomLabelInput.Input
                                type='text'
                                name='exchangeReShipmentReceiverContact2'
                                onChange={handleChangeValue}
                                value={editableReturnExchange?.exchangeReShipmentReceiverContact2 || ''}
                            />
                            <CustomLabelInput.Label>수취인 전화번호2</CustomLabelInput.Label>
                        </CustomLabelInput>
                        <CustomLabelInput>
                            <CustomLabelInput.Input
                                type='text'
                                name='exchangeReShipmentDestination'
                                onChange={handleChangeValue}
                                value={editableReturnExchange?.exchangeReShipmentDestination || ''}
                            />
                            <CustomLabelInput.Label>주소</CustomLabelInput.Label>
                        </CustomLabelInput>
                        <CustomLabelInput>
                            <CustomLabelInput.Input
                                type='text'
                                name='exchangeReShipmentDestinationDetail'
                                onChange={handleChangeValue}
                                value={editableReturnExchange?.exchangeReShipmentDestinationDetail || ''}
                            />
                            <CustomLabelInput.Label>주소상세</CustomLabelInput.Label>
                        </CustomLabelInput>
                        <CustomLabelInput>
                            <CustomLabelInput.Input
                                type='text'
                                name='exchangeReShipmentZipCode'
                                onChange={handleChangeValue}
                                value={editableReturnExchange?.exchangeReShipmentZipCode || ''}
                            />
                            <CustomLabelInput.Label>우편번호</CustomLabelInput.Label>
                        </CustomLabelInput>
                        <CustomSelect
                            name='exchangeReShipmentDeliveryCompanyCode'
                            onChange={handleChangeValue}
                            value={editableReturnExchange?.exchangeReShipmentDeliveryCompanyCode || ''}
                        >
                            <option value=''>선택</option>
                            {deliveryCompanyCodes?.map((item, index) => {
                                return (
                                    <option value={item?.code} key={item?.code}>{item?.name}</option>
                                )
                            })}
                        </CustomSelect>
                        <CustomLabelInput>
                            <CustomLabelInput.Input
                                type='text'
                                name='exchangeReShipmentWaybillNumber'
                                onChange={handleChangeValue}
                                value={editableReturnExchange?.exchangeReShipmentWaybillNumber || ''}
                            />
                            <CustomLabelInput.Label>송장번호</CustomLabelInput.Label>
                        </CustomLabelInput>
                        <CustomLabelInput>
                            <CustomLabelInput.Input
                                type='number'
                                name='exchangeReShipmentDeliveryCharge'
                                onChange={handleChangeValue}
                                value={editableReturnExchange?.exchangeReShipmentDeliveryCharge || ''}
                            />
                            <CustomLabelInput.Label>재출고 배송비</CustomLabelInput.Label>
                        </CustomLabelInput>
                        <CustomLabelInput>
                            <CustomLabelInput.Input
                                type='text'
                                defaultValue={returnExchange?.exchangeReShipmentAt ? CustomDateUtils().dateToYYYYMMDDhhmmss(returnExchange?.exchangeReShipmentAt) : '미출고 상태'}
                                disabled
                            />
                            <CustomLabelInput.Label>교환재출고일시</CustomLabelInput.Label>
                        </CustomLabelInput>
                    </StyledModalBody>
                    <StyledModalFooter>
                        <CustomBlockButton
                            type='submit'
                        >적용</CustomBlockButton>
                    </StyledModalFooter>
                </form>
            </CustomDialog>

            {productOptionSelectModalOpen &&
                <GlobalWegetProductOptionModal
                    open={productOptionSelectModalOpen}
                    onClose={() => setProductOptionSelectModalOpen(false)}
                    onSelectItem={(item) => handleSelectProductOption(item)}
                />
            }
        </>
    );
}

/**
 * 이 페이지에서 수정되는 항목
exchange_release_option_code
exchange_release_quantity
exchange_re_shipment_at
exchange_re_shipment_waybill_number
exchange_re_shipment_destination
exchange_re_shipment_destination_detail
exchange_re_shipment_receiver
exchange_re_shipment_receiver_contact1
exchange_re_shipment_receiver_contact2
exchange_re_shipment_delivery_charge
 */